/**
 * @generated SignedSource<<22abfdf8334610a9217eeece7e6a12ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecipientAvatar_Recipient$data = {
  readonly __typename: "ChatBot";
  readonly avatarUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "RecipientAvatar_Recipient";
} | {
  readonly __typename: "User";
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatarContainer_User">;
  readonly " $fragmentType": "RecipientAvatar_Recipient";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "RecipientAvatar_Recipient";
};
export type RecipientAvatar_Recipient$key = {
  readonly " $data"?: RecipientAvatar_Recipient$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecipientAvatar_Recipient">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecipientAvatar_Recipient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarContainer_User"
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        }
      ],
      "type": "ChatBot",
      "abstractKey": null
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};

(node as any).hash = "29fa5668f4e5db5ccf81f169c1c1aef4";

export default node;
